import { Tabs as MantineTabs } from '@mantine/core';

export const Tabs = MantineTabs.extend({
	defaultProps: {
		variant: 'pills',
		size: 'sm',
		keepMounted: false,
	},
});
